import Script from 'next/script';
import { ASSET_BASE_URL } from '../../constants';
import { useCookie } from '../../context/CookieContext';
import FunctionalScripts from './FunctionalScripts';
import AnalyticsScripts from './AnalysticsScripts';
import MarketingScripts from './MarketingScripts';

// NOTE: google tag manager scripts requires id checking, cannot be hosted locally
export default function ExternalScripts({ nonce }) {
	const {consent} = useCookie();
	return (
		<>
			<Script id="font-awesome-css" nonce={nonce} strategy="afterInteractive">
				{`
					if (!document.getElementById('font-awesome-stylesheet')) {
						const link = document.createElement('link');
						link.id = 'font-awesome-stylesheet';
						link.rel = 'stylesheet';
						link.href = '${ASSET_BASE_URL}/font-awesome/css/all.min.css';
						document.head.appendChild(link);
					}
				`}
			</Script>
			<FunctionalScripts nonce={nonce} consent={consent} />
			{consent?.analytics && <AnalyticsScripts nonce={nonce} />}
			{consent?.marketing && <MarketingScripts nonce={nonce} />}
		</>
	);
}
